import React, { createContext, useState, useContext } from "react";
const ParamsContext = createContext(undefined);
export const ParamsProvider = ({ children, }) => {
    const [routeParams, setRouteParamsState] = useState(new Map());
    const setRouteParams = (route, params) => {
        setRouteParamsState((prev) => {
            const newMap = new Map(prev);
            if (Array.from(params.entries()).length === 0) {
                newMap.delete(route);
            }
            else {
                // Create a new URLSearchParams instance to avoid reference issues
                const paramsCopy = new URLSearchParams(params.toString());
                newMap.set(route, paramsCopy);
            }
            return newMap;
        });
    };
    return (React.createElement(ParamsContext.Provider, { value: { routeParams, setRouteParams } }, children));
};
export const useParamsContext = () => {
    const context = useContext(ParamsContext);
    if (!context) {
        throw new Error("useParamsContext must be used within a ParamsProvider");
    }
    return context;
};
